/**
 * Titan V8 — Vite entry point
 *
 * titan_v8.jsx was written for the in-browser Babel transpile path and
 * expects React on `window.React`, plus it sets `window.TitanApp = App`
 * at the bottom. We honor that contract here so we do not have to
 * rewrite the 3,000+ line component file. Vite-built and Babel-dev
 * paths are now functionally identical from titan_v8.jsx's perspective.
 */
import React from "react";
import ReactDOM from "react-dom/client";
import * as THREE from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js";

// Expose React + Three.js globals BEFORE titan_v8.jsx runs.
window.React = React;
window.ReactDOM = ReactDOM;
window.THREE = THREE;
window.TitanThreeOrbitControls = OrbitControls;
// Backend base — empty when served same-origin (Render prod), Vite dev hits the proxy.
window.TITAN_API_BASE = window.TITAN_API_BASE ?? "";

async function bootstrap() {
  const $boot = document.getElementById("boot");
  const $status = $boot?.querySelector(".status");
  const setStatus = (t) => { if ($status) $status.textContent = t; };

  setStatus("Loading Titan V8 modules...");

  try {
    // Dynamic import so React globals above are set first.
    await import("@titan");
  } catch (e) {
    console.error("[Titan boot] failed to load titan_v8.jsx", e);
    setStatus("Failed to load — see console");
    throw e;
  }

  if (!window.TitanApp) {
    setStatus("TitanApp not registered — boot aborted");
    throw new Error("window.TitanApp was not set by titan_v8.jsx");
  }

  setStatus("Mounting...");
  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(React.createElement(window.TitanApp));

  // Fade out boot splash after first paint
  requestAnimationFrame(() => {
    if ($boot) {
      $boot.style.opacity = "0";
      setTimeout(() => $boot.remove(), 300);
    }
  });
}

bootstrap();
